import { Routes } from '@angular/router';
import { ProductsComponent } from './products/products.component';
import { ProductComponent } from './product/product.component';
import { Paths, SemiPath } from '../../../config/config';
import { ProductResolverService } from './product/product-resolver.service';
const ɵ0 = {
    page: Paths.Products
}, ɵ1 = () => import("./../kit/kit.module.ngfactory").then(r => r.KitModuleNgFactory);
const routes = [
    {
        path: '',
        component: ProductsComponent,
        data: ɵ0
    },
    {
        path: SemiPath.Kit,
        loadChildren: ɵ1
    },
    {
        path: ':slug',
        component: ProductComponent,
        resolve: {
            product: ProductResolverService
        }
    }
];
export class ProductsRoutingModule {
}
export { ɵ0, ɵ1 };
